module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/calendar/CalendarListRow.ejs -->\n';

    var employee = leaveRequest.getEmployee();
    var leaveType = leaveRequest.getType();

__p+='\n<tr class="is-clickable" onclick="document.location = \''+
((__t=( leaveRequest.getLink() ))==null?'':_.escape(__t))+
'\';">\n    <td data-cy="location">'+
((__t=( employee.getCompanyLocationName() ))==null?'':_.escape(__t))+
'</td>\n    <td data-cy="employeeName">'+
((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
'</td>\n    <td data-cy="leaveType">'+
((__t=( leaveType.get('name') ))==null?'':_.escape(__t))+
'</td>\n    <td data-cy="leaveStartDate">'+
((__t=( leaveRequest.getFormattedDateFrom() ))==null?'':_.escape(__t))+
'</td>\n    <td data-cy="leaveEndDate">'+
((__t=( leaveRequest.getFormattedDateTo() ))==null?'':_.escape(__t))+
'</td>\n    <td data-cy="leaveStatus" class="text-bold '+
((__t=( leaveRequest.getStatusColor() ))==null?'':_.escape(__t))+
'">'+
((__t=( leaveRequest.getStatusText() ))==null?'':_.escape(__t))+
'</td>\n</tr>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/calendar/CalendarListRow.ejs
// module id = 903
// module chunks = 1